<template>
  <div class="group container">
    <h3>代表者メールアドレス入力</h3>
    <div v-if="!showResult">
      <validation-observer v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div>ご入力いただいたメールアドレス宛てに，登録用ページのURLをお送りいたします。</div>
            <div class="text-danger">「daiichi-g.co.jp」ドメインからのメール受信を許可するよう，設定をお願いいたします。</div>
          </div>
          <div class="form-group col-12">
            <label for="txtMail">メールアドレス <span class="badge badge-danger">必須</span></label>
            <div class="form-row">
              <div class="col-12">
                <validation-provider rules="required|email" vid="mail" v-slot="{ errors }">
                  <input type="mail" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtMail" v-model="mail">
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <label for="txtMailValidate">メールアドレス（確認用） <span class="badge badge-danger">必須</span></label>
                <validation-provider rules="required|mail-confirm:mail" v-slot="{ errors }">
                  <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtMailValidate" v-model="mailValidate">
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
          </div>
          <!-- ナビゲーションボタン -->
          <div class="form-row">
            <div class="col-6 mx-auto">
              <button type="submit" class="btn btn-lg btn-primary btn-block next_button" :disabled="disableSubmit">ご案内メール送信</button>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
    <div v-else>
      <div v-if="showError">
        <div class="row">エラーによりメール送信ができませんでした。</div>
        <div class="row">エラー番号：{{ resultState }}</div>
        <div class="row">{{ errMessage }}</div>
      </div>
      <div v-else>
        <div class="row">アドレス「{{ mail }}」宛てに，件名「第一学習社 新課程オンラインセミナー 申込ページのご案内」のメールを送信しました。</div>
        <div class="row">
          メールに記載されたURLから登録画面を表示し，登録を行ってください。
          <span class="row text-danger">（URLは24時間有効です。）</span>
        </div>
        <div class="row">しばらく待ってもメールが届かない場合は，アドレスをご確認のうえ，再度ご登録ください。</div>
      </div>
      <div class="row">
        <div class="mx-auto">
          <router-link tag="button" class="btn btn-lg btn-secondary" to="/">戻る</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import err from '@/err'
import axios from 'axios'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { setInteractionMode } from 'vee-validate'
import { required, email, confirmed } from  'vee-validate/dist/rules'

setInteractionMode('passive')

extend('required', {
  ...required,
  message: 'ご入力ください'
})
extend('email', {
  ...email,
  message: '不正なメールアドレス形式です'
})
extend('mail-confirm', {
  ...confirmed,
  message: 'メールアドレスの入力値が異なります'
})

export default {
  name: "ConfirmMail",
  data() {
    return {
      showResult: false,
      resultState: err.UNKNOWN,
      disableSubmit: false,
      mail: "",
      mailValidate: ""
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    showError() {
      return this.resultState != err.OK
    },
    errMessage() {
      return err.desc[this.resultState]
    }
  },
  mounted() {
    document.getElementById('html').scrollTop = 0
  },
  methods: {
    onSubmit() {
      this.disableSubmit = true
      let params = new URLSearchParams()
      params.append("event", this.$store.state.entry.event)
      params.append("mail", this.mail)
      axios.post(process.env.VUE_APP_BASE_URL + "api/mail_entry.asp", params)
        .then(res => {
          window.console.log('entry mail result:', res.data)
          this.resultState = res.data.state
          this.showResult = true
        })
        .catch(e => {
          window.console.warn('error', e)
          this.resultState = err.UNKNOWN
          this.showResult = true
        })
    }
  }
}
</script>
